import { Icon } from '../types/icon.type';

export const ICON_DATA: Icon[] = [
  'calendar',
  'check_done_step',
  'edit',
  'trading',
  'quick_link',
  'promotion',
  'opportunities',
  'help_support',
  'current_balance',
  'attach_file',
  'recycle_bin',
  'eraser',
  'file_text',
];
